<!-- Button -->

<div *ngIf="!user">
        <div class="flex items-center">
            <mat-icon aria-hidden="false" aria-label="Example thumbs up SVG icon" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span class="font-semibold ml-1.5 text-xl text-white">Accedi all'area personale</span>
        </div>
</div>


<div *ngIf="user">
    <button [matMenuTriggerFor]="userActions">
        <div class="flex items-center">
            <mat-icon aria-hidden="false" aria-label="Example thumbs up SVG icon" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span class="font-semibold ml-1.5 text-base text-white">{{user?.fullname}}</span>
        </div>
    </button>
</div>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
     <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Login effettuato come:</span>
            <span class="mt-2 font-medium text-center text-white">{{user?.fullname}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:book-open'"></mat-icon>
        <span routerLink="/">Le mie istanze</span>
    </button>
    <button *ngIf="user?.usermode=='spid'" mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
        <span (click)="vai()" >Le mie prenotazioni</span>
    </button>
    <button *ngIf="user?.usermode!='spid'" mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
        <span routerLink="/area-istruttore" >Area istruttore</span>
    </button>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Esci</span>
    </button>
</mat-menu>
